import { defineMessages } from "react-intl";

export const messages = defineMessages({
  cancel: {
    defaultMessage: "Cancel",
    description: "Abandon the current action and close without saving",
  },
});

export default messages;
